import {Button, Form, Input, Modal} from "antd"
import React, {useEffect} from "react"
import {useDispatch} from "react-redux"
import {pageLoadingSActions} from "../../common/store/page-loading.state"
import {getCompetitor, updateCompetitor} from "../../service/competitor.service"
import {notificationActions} from "../../common/store/notification.state"
import {ICompetitor} from "../../model/competitor.model"

interface Props {
    readonly isOpen: boolean
    readonly close: () => void
    readonly competitorId: number
}


export const EditCompetitorModal = ({competitorId, close, isOpen}: Props) => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()

    useEffect(() => {
        if (competitorId) {
            dispatch(pageLoadingSActions.showLoading())
            getCompetitor(competitorId).subscribe(value => {
                dispatch(pageLoadingSActions.hideLoading())
                if (value) {
                    form.setFieldsValue(value)
                } else {
                    dispatch(notificationActions.error({message: "Competitore non trovato."}))
                    close()
                }
            })
        }
    }, [competitorId])

    const save = () => {
        const competitor = form.getFieldsValue() as ICompetitor
        updateCompetitor(competitorId, competitor.name!, competitor.surname!).subscribe(() => close())
    }

    return (
        <>
            <Modal title="Modifica i dati dell'atleta" open={isOpen} onCancel={close} footer={[
                <Button key="help-modal-cancel-button" type="default" onClick={close}>
                    Annulla
                </Button>,
                <Button key="help-modal-confirm-button" type="primary" onClick={save}>
                    Salva
                </Button>
            ]}>
                <Form
                    layout="vertical"
                    size="middle"
                    name="updateCompetitorForm"
                    form={form}
                >
                    <Form.Item
                        label="Codice fiscale"
                        name={"fiscalCode"}
                    >
                        <Input disabled={true}/>
                    </Form.Item>
                    <Form.Item
                        label="Nome"
                        name={"name"}
                        rules={[{required: true, message: 'Nome obbligatorio'}]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Cognome"
                        name={"surname"}
                        rules={[{required: true, message: 'Cognome obbligatorio'}]}
                    >
                        <Input/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
